import React from "react";
import Sidebar from "./Sidebar.js";

const Layout2 = ({ children }) => {
  return (
    <div className="flex">
      <Sidebar />
      <div className="ml-64 p-10 w-full">{children}</div>
    </div>
  );
};

export default Layout2;
